import React, { useRef, useEffect, useState } from 'react'
import { Splide, SplideSlide } from '@splidejs/react-splide';
import Slider from "react-slick";
import '@splidejs/react-splide/css';
import { Player, BigPlayButton } from 'video-react';
import axios from 'axios';
import Overlay from 'react-bootstrap/Overlay';
import Tooltip from 'react-bootstrap/Tooltip';
import Container from 'react-bootstrap/Container';
import Banner from '../assets/images/banner.jpg';
import Poster from '../assets/images/background/poster.png';
import Logo from '../assets/images/logo.svg';
import nyck from '../assets/images/logos/Nyck_De_Vries.png';
import Coingecko from '../assets/images/logos/coingecko.png';
import cmc from '../assets/images/logos/cmc.png';
import ldacap from '../assets/images/logos/ldacap.png';
import DemoSlide from '../assets/images/slider.png';
import DemoSlide2 from '../assets/images/slider2.png';
import DemoSlide3 from '../assets/images/slider3.png';
import UnrealEngine from '../assets/images/ue-logo.png';
import Spring from '../assets/images/shapes/spring.svg';
import NFT from '../assets/images/nft-services.svg';
import Stunning from '../assets/images/stunning-visual.svg';
import LogoSpring from '../assets/images/logo-with-spring.svg';
import Video from '../assets/video/MBD.mp4';


import Check from '../assets/images/icons/check.svg';
import OutlineCircle from '../assets/images/icons/outline-circle.svg';

import Logo2 from '../assets/images/logo-2.svg';
import Rotate from '../assets/images/rotate-with-logo.svg';

import File1 from '../assets/images/file1.svg';
import File2 from '../assets/images/file2.svg';
import File3 from '../assets/images/file3.svg';
import CaseStudies from '../Component/Modal/caseStudies';
import JoinOurWaitlist from '../Component/Modal/JoinOurWaitlist';
import TradeMBD from '../Component/Modal/TradeMBD';
import { Link, useLocation } from 'react-router-dom';

import certik from '../assets/images/logos/certik.png';
import mexc from '../assets/images/logos/mexc.png';
import paladinsec from '../assets/images/logos/paladinsec.png';
import nvidia from '../assets/images/logos/nvidia.png';
import microsoft from '../assets/images/logos/microsoft.png';
import tier7trading from '../assets/images/logos/tier7trading.png';
import Quytech from '../assets/images/logos/quytech.png';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);


const Landing = () => {

    //   const splideRef = useRef(null);

    //   const handleNextClick = () => {
    //     if (splideRef.current) {
    //       const splide = splideRef.current.splide;
    //       splide.go('>');
    //     }
    //    };
    //     const handlePreviousClick = () => {
    //         if (splideRef.current) {
    //           const splide = splideRef.current.splide;
    //           splide.go('<');
    //         }
    //     };


    
    const target = useRef(null);
    const [tool, setTool] = useState(false);
    const [modalText, setModalText] = useState("");
    const [show, setShow] = useState(false);

    const [para, setPara] = useState(false);

    const [caseStudiesShow, setCaseStudiesShow] = useState(false);

    const handlecaseStudiesClose = () => setCaseStudiesShow(false);
    const handlecaseStudiesShow = (text) => {
        setModalText(text)
        setCaseStudiesShow(true)
    };


    const [waitListShow, setWaitListShow] = useState(false);

    const handleWaitListClose = () => setWaitListShow(false);
    const handleWaitListShow = () => setWaitListShow(true);


    const [tradeShow, setTradeShow] = useState(false);

    const handleTradeClose = () => setTradeShow(false);
    const handleTradeShow = () => setTradeShow(true);

    const settings = {
        dots: false,
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        speed: 2000,
        autoplaySpeed: 2000,
        cssEase: "linear",
        arrows:false,
        className: "center",
        responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
              }
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                initialSlide: 2,
              }
            },
          ]
      };
    
    const [signUpEmail,setSignUpEmail] = useState("")
    const [error,setError] = useState("")
    const [messageFlag,setMessageFlag] = useState(false)
    const [message2Flag,setMessage2Flag] = useState(false)
    const [sendButton,setSendButton] = useState(false)

    const sendEmail = async () => {
        console.log("signUpEmail",signUpEmail);
        if(!signUpEmail){
            setError("Email field is require!")
            setTimeout(()=>{
                setError("")
            },2000)
            return
        }
        setSendButton(true)

    axios
    .post('http://quytech.net:3003/signUpEmail', { email:signUpEmail },
    { headers: { 'Content-Type': 'application/json' }})
    .then((res) => {
      console.log("res",res);
      if(res.data.status == true){
        setSignUpEmail("")
        setSendButton(false)
        setMessageFlag(true)
        setTimeout(()=>{
            setMessageFlag(false)
        },2000)
      }else{
        setSignUpEmail("")
        setSendButton(false)
        setMessage2Flag(true)
        setTimeout(()=>{
            setMessage2Flag(false)
        },2000)
      }
    })
    .catch((err) => {
      
    });
    }

    return (
        <>


            <section className="banner d-flex align-items-md-end align-items-center full-banner" style={{ backgroundImage: `url(${Banner})` }}>
                <div className="container mb-150">
                    <div className="text-center">
                        <span className="logo">
                            <img src="./assets/images/logo.svg" alt="" />
                        </span>
                    </div>
                    <div className="row align-items-center">
                        <div className="col-lg-8 pt-md-3 pt-0 banner__content">
                            {/* <h2 className="fw-light">Hyper Realistic</h2> */}
                            <h1 className="fw-light">MBD Financials</h1>
                            <p className='col-lg-10 px-0 my-4 fw-light pe-md-5'>Discover a photorealistic Business District powered by AI, bridging the gap between the
                                real and virtual realms.</p>
                            <a className='btn btn-primary rounded-pill btn-xl' href='#image-section'>Learn More</a>
                        </div>

                    </div>
                </div>
            </section>
            <section className='py-md-5 py-3'>
                <div className="container-fluid py-md-5 py-3">
                <div className="slider-container">
                    <Slider aria-label="Comapany logos" {...settings}>
                        <div className='d-flex justify-content-center align-items-center px-3'>
                            <Link target='_blank' to="https://www.ldacap.com/"><img src={ldacap} alt="ldacap" /></Link>
                        </div>
                        <div className='d-flex justify-content-center align-items-center px-3'>
                            <Link target='_blank' to="https://www.coingecko.com/en/coins/mbd-financials"><img src={Coingecko} alt="coingecko" /></Link>
                        </div>
                        <div className='d-flex justify-content-center align-items-center px-3'>
                            <Link target='_blank' to="https://coinmarketcap.com/currencies/mbd-financials/"><img src={cmc} alt="cmc" /></Link>
                        </div>
                        <div className='d-flex justify-content-center align-items-center px-3'>
                            <Link target='_blank' to="https://www.mexc.com/exchange/MBD_USDT?_from=header"><img src={mexc} alt="mexc" /></Link>
                        </div>
                        <div className='d-flex justify-content-center align-items-center px-3'>
                            <Link target='_blank' to="https://www.nvidia.com/en-us/"><img src={nvidia} alt="nvidia" width="250" /></Link>
                        </div>
                        <div className='d-flex justify-content-center align-items-center px-3'>
                            <Link target='_blank' to="https://www.microsoft.com/en-us/"><img src={microsoft} alt="microsoft" height="90" /></Link>
                        </div>
                        <div className='d-flex justify-content-center align-items-center px-3'>
                            <Link target='_blank' to="https://www.tier7trading.com/"><img src={tier7trading} alt="tier7trading" height="100" /></Link>
                        </div>
                        <div className='d-flex justify-content-center align-items-center px-3'>
                            <Link target='_blank' to="https://paladinsec.co/projects/mbd-financials/"><img src={paladinsec} alt="paladinsec" height="100" /></Link>
                        </div>
                        <div className='d-flex justify-content-center align-items-center px-3'>
                            <Link target='_blank' to="https://skynet.certik.com/projects/mbd-financials"><img src={certik} alt="certik" /></Link>
                        </div>
                        <div className='d-flex justify-content-center align-items-center px-3'>
                            <Link target='_blank' to="https://www.quytech.com/"><img src={Quytech} alt="Quytech" /></Link>
                        </div>
                        
                    </Slider>
                    </div>
                </div>
            </section>            
            <section className="pb-5 overflow-visible">
                <div className="container">
                    <div className="text-center col-lg-11 mx-auto">
                        {/* <span className='title-sm'>New! welcome to MBD Financials</span> */}
                        <h2 className="title-h2 mt-3 fw-light px-md-5">MBD Financials is a <span className="gradient-text-1 fw-medium">Photorealistic Metaverse Business District</span> bridging some of
                            the largest gaps in the Defi, Metaverse, and Web3 landscape.</h2>
                        <p className="mt-4 opacity-75 fw-light col-md-9 mx-auto px-0 mb-0">Experience our comprehensive ecosystem encompassing Phygital Marketplace,
                            Digital Real Estate, Financial District, Education, Entertainment, and Health; all
                            crafted to revolutionize your journey in both the virtual and real worlds!</p>
                        <div className={`${show == false ? 'd-block' : 'd-none'}`}>
                            <span className='three-dots'>&bull;&bull;&bull;</span>
                        </div>
                        <button className={`btn btn-outline-white rounded-pill btn-md py-2 px-4 lh-1 ${show == false ? 'd-inline-block' : 'd-none'}`} onClick={() => setShow(!show)}>Read More</button>
                        <p className={`mt-4 opacity-75 fw-light col-md-9 mx-auto px-0 mb-0 ${show ? 'd-block' : 'd-none'}`}>Explore a world where luxurious virtual properties and the contents within them
                            are investments rather than just pixels. We're redefining asset value with
                            everything from vintage cars that roar to life in both domains to art collections
                            that tell a story across generations.</p>
                        <div className="d-grid gap-3 d-md-flex mt-5 justify-content-center">
                            <button
                                className='btn btn-primary rounded-pill btn-md py-3' ref={target} onClick={() => setTool(!tool)} onMouseEnter={() => setTool(true)}>Trade MBD</button>
                            <Overlay target={target.current} show={tool} placement="top">
                                {(props) => (
                                    <Tooltip className='custom-trade-tooltip' id="overlay-example" {...props} onMouseLeave={() => setTool(false)}>
                                        <div className='d-grid gap-4 text-center tradedesign'>
                                            <Link className='tradeLink' to="https://app.uniswap.org/explore/tokens/ethereum/0xa08898cabe14680cdfea55398143bc120889182e" target='_blank'>MEXC</Link>
                                            <Link className='tradeLink' to="https://www.mexc.com/login?inviteCode=1caSw" target='_blank'>Uniswap</Link>
                                        </div>
                                    </Tooltip>
                                )}
                            </Overlay>
                            <Link target='_blank' to="https://www.geckoterminal.com/eth/pools/0xfb9f9fb4ad3c73a817605338e6867dc372810c58" className='btn btn-primary rounded-pill btn-md py-3'>View Chart</Link>
                        </div>

                        <div className='mt-5 pt-4'>
                            <p className='mb-0 title-h2 fw-bold'>We're Not Just A Platform, We're A <span className='gradient-text-1'>Revolution</span></p>
                            <span className='title-h2'>Be part of the future, today!</span>
                        </div>
                    </div>
                </div>
            </section>
            <div className="pin">
                <div className="wrapper" id="image-section">
                    <canvas id="hero-lightpass" width="1900" height="1080" />
                    <div className="caption">
                        <div className="list">
                            <ul>
                                <li className="active">MBD Financial District</li>
                                <li>MBD Boulevard</li>
                                <li>MBD Wellness District</li>
                                <li>MBD Education District</li>
                            </ul>
                        </div>
                        <div className="brief">
                            <div className="item active">
                                <h3>MBD Financial District</h3>
                                <h5>Where Innovation Meets Financial Freedom</h5>
                                <p>Where centralized and decentralized financial services are seamlessly integrated for the modern economy. Our immersive platform is designed to empower financial independence for individuals and businesses alike, offering comprehensive tools for trading, investing, enterprise management, and more, all crafted to pave your path to financial independence. MBD provides access to an advanced financial ecosystem, giving you complete control over your financial decisions.</p>
                                <a onClick={() => handlecaseStudiesShow("Financial")}>Read More</a>
                            </div>
                            <div className="item">
                                <h3>MBD Boulevard</h3>
                                <h5>Cross-chain AI Phygital Marketplace with Real World Asset.</h5>
                                <p>From digital discovery to physical fulfillment. MBD Boulevard is not just a concept; it's a revolution in the commerce landscape. Imagine a place  here technology and innovation converge to create unparalleled shopping experiences.</p>
                                <a onClick={() => handlecaseStudiesShow("Boulevard")}>Read More</a>
                            </div>
                            <div className="item">
                                <h3>MBD Wellness District</h3>
                                <p>Your premier destination for comprehensive health and wellness solutions. Discover our innovative hub, where cutting-edge healthcare technologies and community support merge to optimize your well-being.</p>
                                <a onClick={() => handlecaseStudiesShow("Wellness")}>Read More</a>
                            </div>
                            <div className="item">
                                <h3>MBD Education District</h3>
                                <h5>Unlocking Opportunity- Learn, Earn, Grow at MBD Education District</h5>
                                <p>A comprehensive educational ecosystem where individuals can access a wide range of resources, including university courses, vocational training, skill development programs, and work opportunities, all within a dynamic digital environment. Whether it's acquiring new skills, advancing careers, or exploring entrepreneurial opportunities, our MBD Education District provides a platform for lifelong learning and professional development.</p>
                                <a onClick={() => handlecaseStudiesShow("Education")}>Read More</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='overflow-hidden'>
                <section className="py-10 overflow-visible">
                    <div className="container-fluid">
                        <div className='pb-4'>
                            <Splide aria-label="slider" options={{
                                type: 'carousel',
                                rewind: true, // Optional: Whether to loop the slider
                                autoplay: true, // Enable autoplay
                                interval: 3000, // Autoplay interval in milliseconds
                                pauseOnHover: false,
                                perPage: 1,
                                gap: '1rem',
                                arrows: false,
                                classes: {
                                    pagination: 'splide__pagination pill-pagination',
                                }
                            }}>
                                <SplideSlide className='d-flex justify-content-center align-items-center'>
                                    <img src={DemoSlide} alt="Slide" />
                                </SplideSlide>
                                <SplideSlide className='d-flex justify-content-center align-items-center'>
                                    <img src={DemoSlide2} alt="Slide" />
                                </SplideSlide>
                                <SplideSlide className='d-flex justify-content-center align-items-center'>
                                    <img src={DemoSlide3} alt="Slide" />
                                </SplideSlide>

                            </Splide>
                        </div>
                    </div>
                    <div className="container">
                        <div className="text-center col-lg-10 mx-auto px-0 mt-5">
                            <h2 className="title-h2 mb-1 fw-bold">MBD Boulevard</h2>
                            <h3 className="title-h2 mb-0 fw-bold gradient-text-1">AI Cross-Chain Phygital Marketplace with RWA</h3>
                            <h3 className="mt-3 h7 fw-light">Discover, Explore, Transform</h3>
                            <h4 className="mt-3 fs-23 fw-light">Dive into the phygital Web3 world, from pixels to reality!</h4>
                            <div className={`mt-4 mb-md-5 mb-3  ${para ? 'd-none' : 'd-block'}`}>
                                <button className={`btn btn-outline-white rounded-pill btn-md py-2 px-4 lh-1 mt-2`} onClick={() => setPara(!para)}>Read More</button>
                            </div>
                            <p className={`mt-4 pb-5 opacity-75 fw-light mx-auto px-0 mb-0 ${para == false ? 'd-none' : 'd-block'}`}>Our platform bridges the gap between virtual and real-world assets, amplifying
                                transactional value and enriching brand experiences. With capabilities for launching
                                physical products for Web2, digital assets for Web3, and phygital solutions bridging
                                Web2 and Web3, we redefine the future of commerce and real-world asset integration.</p>
                          <section className="py-10">
  <div className="container text-center">
    <h2 className="title-h2 mb-3 fw-bold gradient-text-1">
      Explore Gold-Backed Digital Collectibles
    </h2>
    <p className="mt-3 fw-light opacity-75 col-md-8 mx-auto">
      Digitally certified ownership of real, securely stored gold — uniquely minted as NFTs.
      Redeemable after 12 months with KYC compliance, tradable within the MBD ecosystem.
    </p>
    <p className="fw-light opacity-75 col-md-8 mx-auto mb-4">
      These collectibles bring physical value to your digital identity — ideal for Web3 pioneers and collectors alike.
    </p>
    <a
      href="https://mbdblvdrwa.com/"
      target="_blank"
      rel="noopener noreferrer"
      className="btn btn-primary rounded-pill btn-lg px-5 mt-3"
    >
      Visit Gold NFT Platform
    </a>
  </div>
</section>
  
                        </div>
                    </div>
                </section>

                {/* <section className="py-10 overflow-visible">
                    <div className="container">
                        <div className="row flex-md-row flex-column-reverse gap-md-0 gap-5">
                            <div className="col-md-6">
                                <div className='text-md-start text-center'>
                                    <span className='title-sm'>Powerful Tools</span>
                                    <h2 className="mt-0 fw-light">Metaverse powered by unreal engine 5</h2>
                                    <p className="p-md mt-2 mb-0 fw-light opacity-50">Lorem ipsum is a placeholder text commonly used demonstrate the visual form of a document or a typeface</p>
                                    <img src={Spring} alt="shapes" className='opacity-50 ms-n3' />
                                </div>
                            </div>
                            <div className="col-md-6 text-center">
                                <img src={UnrealEngine} alt="unreal engine" className='powerful-tool-img' />
                            </div>
                        </div>
                    </div>
                </section>
                <section className="py-10 overflow-visible">
                    <div className="container">
                        <div className="row align-items-center flex-md-row flex-column-reverse gap-md-0 gap-5">
                            <div className="col-md-6">
                                <div className='text-md-start text-center'>
                                    <span className='title-sm'>Stunning Visuals</span>
                                    <h2 className="mt-0 fw-light">Cross platform interoperability</h2>
                                    <p className="p-md mt-2 mb-0 fw-light opacity-50 col-lg-8">AR/MR/VR compatible. Virtual store solution for B2C & B2B.Virtual and real world physical assets.</p>
                                </div>
                            </div>
                            <div className="col-md-6 text-center">
                                <img src={Stunning} alt="Stunning Visual" className='zoom-in-zoom-out stuning-img' />
                            </div>
                        </div>
                    </div>
                </section> */}


                <section className="py-10 overflow-visible">
                    <div className="container">
                        <div className="row align-items-center gap-lg-0 gap-5">
                            <div className="col-lg-7 text-md-start text-center">
                                <div className='rounded-5 overflow-hidden text-center col-md-10 px-0 mx-auto' >

                                    <Player autoPlay={false} muted className='rounded-5' poster={Poster} src={Video} >
                                        <BigPlayButton position="center" />
                                    </Player>
                                </div>
                                
                            </div>
                            <div className="col-lg-5">
                                <div className='text-md-start text-center'>
                                    <h3 className="h7 mt-0 mb-0 fw-light">Welcome To MBD Financials:</h3>
                                    <h3 className="h7 mt-0 mb-4 fw-bold gradient-text-1">Where The Future Is Now.</h3>
                                    <p className="p-md mt-1 mb-0 fs-13">Step into the future with MBD Financials: where the Metaverse meets reality. Prepare for a journey beyond imagination as we redefine digital interaction. Powered by Unreal Engine 5, our Photorealistic Metaverse offers unprecedented access to a world like no other. Experience the revolution of Mixed Reality, where virtual meets real in ways you've never seen. Embark on immersive Virtual Reality adventures, exploring boundless digital realms. With cutting-edge MR platforms, we merge the best of both worlds, creating limitless pportunities in a crafted digital landscape.</p>
                                    <span className='h4 lh-base mt-4 d-block fw-light col-xxl-8 col-md-8 col-12 ignite'><em>Ignite the <span className='text-pri'>Metaverse</span>, Seize Your <span className='text-sec'>Opportunity</span>!</em></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="py-10 overflow-visible roadmap-pb-sm">
                    <div className="container">
                        <div className="text-center col-md-8 mx-auto px-0 pb-md-5 pb-3">
                            <span className='title-sm'>Roadmap</span>
                            <h2 className="title-h2 mt-1 fw-light">See what's waiting for you...</h2>
                            <p className="mt-4 opacity-50 fw-light">With the help from our team, contributors and investors, these are the milestones we are looking forward to achieving.</p>
                        </div>
                    </div>
                    <div className="container-fluid px-0 mt-md-5 mt-3">
                        <div className="roadmap-swiper">
                            <Splide aria-label="Comapany logos" options={{
                                classes: {
                                    pagination: 'splide__pagination custom-pagination', // container
                                },
                                wheel: true,
                                releaseWheel: true,
                                arrows: false,
                                pagination: true,
                                perPage: 4,
                                focus: 'center',
                                trimSpace: false,
                                breakpoints: {
                                    320: {
                                        perPage: 2,
                                    },
                                    380: {
                                        perPage: 2,
                                    },
                                    480: {
                                        perPage: 2,
                                    },
                                    767: {
                                        perPage: 2,
                                    },
                                    991: {
                                        perPage: 2,
                                    },
                                    1024: {
                                        perPage: 5,
                                    },
                                    1366: {
                                        perPage: 5,
                                    },
                                    1450: {
                                        perPage: 5,
                                    },
                                },

                            }}>
                                <SplideSlide className='roadmap-swiper-slider-slide'>
                                    <div className='row roadmap-row-first'>
                                        <div className='timeline-count fw-semibold col-4'>Q1</div>
                                        <span className='timeline-heading d-block pe-5 col-8'>
                                            Laying The Groundwork And Pioneering Innovations
                                        </span>
                                    </div>
                                    <div className="row pt-5">
                                        <div className="col-4"></div>
                                        <ul className='timeline-list list-unstyled text-start col-8 pe-0'>
                                            <li className='completed'>MBD/ETH Dex Pairing</li>
                                            <li className='completed'>Marketplace Development 3.0</li>
                                            <li className='completed'>Marketplace- Card Payment Integration</li>
                                            <li className='completed'>BRC-20 Token Integration</li>
                                            <li>MBD Financials Merchandise Expansion (MBD Merch)</li>
                                            <li>Marketing and Branding Launch</li>
                                            <li>Redesigned Project Website</li>
                                            <li>R&D and Licensing for the DeFi Banking Platform</li>
                                        </ul>
                                    </div>
                                </SplideSlide>
                                <SplideSlide className='roadmap-swiper-slider-slide'>
                                    <div className='row roadmap-row-first'>
                                        <div className='timeline-count fw-semibold col-4'>Q2</div>
                                        <span className='timeline-heading d-block pe-5 col-8'>
                                            Expansion And Virtual World Development
                                        </span>
                                    </div>
                                    <div className='row pt-5'>
                                        <div className="col-4"></div>
                                        <ul className='timeline-list list-unstyled text-start col-8 pe-0'>
                                            <li>Top Tier Exchange Listing</li>
                                            <li>Marketplace Gem/Reward Model</li>
                                            <li>Defi Platform Expansion</li>
                                            <li>Continued Marketing Momentum</li>
                                            <li>Token Utility Launch and Expansion</li>
                                        </ul>
                                    </div>
                                </SplideSlide>
                                <SplideSlide className='roadmap-swiper-slider-slide'>
                                    <div className='row roadmap-row-first'>
                                        <div className='timeline-count fw-semibold col-4'>Q3</div>
                                        <span className='timeline-heading d-block pe-5 col-8'>
                                            Community Focus and Metaverse Milestones
                                        </span>
                                    </div>
                                    <div className="row pt-5">
                                        <div className="col-4"></div>
                                        <ul className='timeline-list list-unstyled text-start col-8 pe-0'>
                                            <li>Marketplace Community Section Expansion:</li>
                                            <li>RWA Use Cases Expansion</li>
                                            <li>B2B2C Marketing Expansion</li>
                                            <li>Onboarding Web2 and Web3 Projects</li>
                                            <li>Completion and Launch of DeFi Banking Platform</li>
                                            <li>Pre-Sale of Metaverse Business District Real Estate</li>
                                        </ul>
                                    </div>

                                </SplideSlide>
                                <SplideSlide className='roadmap-swiper-slider-slide'>
                                    <div className="row roadmap-row-first">
                                        <div className='timeline-count fw-semibold col-4'>Q4</div>
                                        <span className='timeline-heading d-block pe-5 col-8'>
                                            Realizing the Future of Digital Real Estate and Innovation
                                        </span>
                                    </div>

                                    <div className="row pt-5">
                                        <div className="col-4"></div>
                                        <ul className='timeline-list list-unstyled text-start col-8 pe-0'>
                                                <li>Community-Driven Expansion</li>
                                                <li>Affiliate Ambassador Program Launch</li>
                                                <li>In-Depth Market Research</li>
                                                <li>MVP Financial Platform</li>
                                                <li>Exclusive MBD Crypto Debit Cards</li>
                                                <li>Launch of Metaverse Business District Real Estate with AR and VR Capabilities</li>
                                            </ul>
                                    </div>
                                </SplideSlide>
                            </Splide>
                        </div>
                    </div>
                </section>
            </div>

            {/* <section className="py-10 overflow-visible ready-to-go">
                <div className="container">
                    <div className="row align-items-center flex-md-row flex-column-reverse gap-md-0 gap-5">
                        <div className="col-md-7">
                            <div className='text-md-start text-center'>
                                <span className='title-sm'>Ready To Go</span>
                                <h2 className="h2-lg lh-1 mt-0 fw-light">Hyper Realistic Metaverse</h2>
                                <p className="p-lg mt-2 mb-2 fw-light opacity-50 col-md-11">Hyper realism is taking over Metaverse spaces as digital experiences more closely replicate physical environments. Brands are embracing realistic aesthetics in their platforms, designs, and spaces, even when the elements they’re portraying aren’t physically possible.</p>
                                <p className='p-lg fw-light mb-0 opacity-50 col-md-11'>According to Vogue, fashion in the metaverse is craving realism right now.</p>
                                <button className='btn btn-primary rounded-pill btn-md mt-4'>Get Started</button>
                            </div>
                        </div>
                        <div className="col-md-5 text-center">
                            <img src={LogoSpring} alt="logo" className='ready-to-go-img' />
                        </div>
                    </div>
                </div>
            </section> */}

            <section className="py-10 overflow-visible">
                <div className="container">
                    <div className="row flex-column">
                        <div className="col-lg-7 col-md-10 text-center mx-auto">
                            <div>
                                <h3 className="fw-light">Sign up for early access & news</h3>
                                <p className="p-lg mt-2 mb-2 fw-light opacity-50">Stay ahead of the curve! Sign up with your email now for exclusive early access
                                    and stay in the loop with the latest updates!</p>
                            </div>
                        </div>
                        <div className="col-lg-5 col-md-8 text-center mx-auto mt-4">
                            <form className='position-relative rounded-pill input-append-button'>
                                <input type="email" className='rounded-pill w-100 h-100' value={signUpEmail} onChange={(e) => setSignUpEmail(e.target.value)} placeholder='Enter Email' required />
                                <button type="button" onClick={() => sendEmail()} disabled={sendButton} className='btn btn-primary rounded-end-pill h-100 position-absolute top-0 end-0 bottom-0'>
                                    Sign Up
                                </button>
                                {
                                    error ? <p style={{color:"red"}}> {error} </p> : ""
                                }
                                {
                                    messageFlag ? <p>Thank you, your subscribe request was successful!.</p> : ""
                                }
                                {
                                    message2Flag ? <p>Given email address is already subscribed, thank you!</p> :""
                                }
                                    
                            </form>
                        </div>
                    </div>
                </div>
            </section>
            <JoinOurWaitlist show={waitListShow} close={handleWaitListClose} />
            <CaseStudies show={caseStudiesShow} close={handlecaseStudiesClose} modalText={modalText} />
            <TradeMBD show={tradeShow} close={handleTradeClose} />
        </>
    )
}

export default Landing